Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'cetelem-installments', function (envelope) {
        var $context = envelope.message.data.context;
        var $controls = $('.x-cetelem-installments', $context);

        if ($controls.length < 1) return;

        $controls.each(function () {
            var $control = $(this);
            var control = $control.get(0);

            var totalPrice = 0;
            var initialPayment = 0;

            var request = undefined;

            control.init = function () {
                var productPrice = $control.data('product-price');
                totalPrice = (typeof productPrice === 'number') ? productPrice : parseFloat(productPrice);
                control.loadPlans();
            };

            control.update = function (model) {
                if (model !== undefined) {
                    var html = Vendd.Handlebars.parse("cetelemInstallments_A", model);
                    $control.html(html);
                }

                var $inputField = $('input[name="initialPayment"]', $control);
                var $updateButton = $('.js-update', $control);

                if (model === undefined) {
                    $inputField.addClass('error');
                    $updateButton.addClass('disabled');
                    return;
                }

                var $selector = $('.js-slider', $control);
                var $selectorValues = $('.selector-value', $control).hide();
                var $selectablePlans = $('.selectable-plan', $control).hide();

                var values = $.map(model.PaymentPlans, function (item) {
                    return item.Installment;
                });

                $selector.ionRangeSlider({
                    type: "single",
                    skin: "flat",
                    values: values,
                    hide_min_max: true,
                    onUpdate: function (data) {
                        $selectorValues.hide().eq(data.from).show();
                        $selectablePlans.hide().eq(data.from).show();
                    },
                    onChange: function (data) {
                        $selectorValues.hide().eq(data.from).show();
                        $selectablePlans.hide().eq(data.from).show();
                    },
                    onFinish: function (data) {
                        $selectorValues.hide().eq(data.from).show();
                        $selectablePlans.hide().eq(data.from).show();
                    }
                });

                $selector.data("ionRangeSlider").update({
                    from: 0
                });

                $inputField.on('change keyup', function (e) {
                    var value = $inputField.val();
                    var floatValue = (0 < value.length) ? parseFloat(value) : 0;

                    if (isNaN(floatValue)) {
                        $inputField.addClass('error');
                        $updateButton.addClass('disabled');
                        initialPayment = 0;
                    } else {
                        $inputField.removeClass('error');
                        if (initialPayment !== floatValue) {
                            initialPayment = floatValue;
                            $updateButton.removeClass('disabled');
                        }
                    }
                });

                $updateButton.addClass('disabled');

                $updateButton.on('click', function (e) {
                    e.preventDefault();

                    if (!$updateButton.hasClass('disabled')) {
                        control.loadPlans();
                    }                
                });
            };

            control.loading = function (loading) {
                if (loading) {
                    $control.addClass('x-loading');
                } else {
                    $control.removeClass('x-loading');
                }
            };

            control.loadPlans = function () {
                if (request !== undefined) {
                    request.abort();
                    request = undefined;
                };

                var url = '/services/api/CetelemInstallments/GetInstallmentsData';
                var data = {
                    totalCost: totalPrice,
                    initialPayment: initialPayment
                };

                request = $.ajax(url, {
                    data: data,
                    beforeSend: function (jqXHR) {
                        control.loading(true);
                    },
                    complete: function (jqXHR, status) {
                        control.loading(false);
                        request = undefined;
                    },
                    success: function (response, status, jqXHR) {
                        if (response && response.success && response.data) {
                            control.update(response.data);
                        }
                        else {
                            control.update();
                        }
                    },
                    error: function (jqXHR, status, error) {
                        if (status === 'abort') {
                            return;
                        }
                        else {
                            control.update();
                        }
                    }
                });
            };

            control.init();
            control.loading(true);
        });
    });
});
